import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

const CartCard = ({cart}) => {

    const {price,name, category,quantity,id}=cart;
    const dispatch = useDispatch();
    const {productList,productAdd, cartItems} = useSelector((state) => state.products);

  return (
    <>
          <div className="cartCard">
    
         <div className="flex items-center col-span-6 space-x-6">
            {/* cart image */}
            <img className="lws-cartImage" src="https://i.dummyjson.com/data/products/40/thumbnail.jpg" alt="product" />
            {/* cart item info */}
            <div className="space-y-2">
              <h4 className="lws-cartName">{name}</h4>
              <p className="lws-cartCategory">Men's clothing</p>
              <p>BDT <span className="lws-cartPrice">1100</span></p>
            </div>
          </div>


        
         
         
          <div className="flex items-center justify-center col-span-4 mt-4 space-x-8 md:mt-0">
            {/* amount buttons */}
            <div className="flex items-center space-x-4">
              <button className="lws-incrementQuantity"  disabled={productList.find(pd=>pd.id==id).quantity < 1 } onClick={()=>dispatch({type:"product/addcart",payload:cart})}  >
                <i className="text-lg fa-solid fa-plus" />
              </button>
              <span className="lws-cartQuantity">{quantity}</span>
              <button className="lws-decrementQuantity"   disabled={quantity <1} onClick={()=>dispatch({type:"cart/decrease",payload:cart})} >
                <i className="text-lg fa-solid fa-minus" />
              </button>
            </div>
            {/* price */}
            <p className="text-lg font-bold">BDT <span className="lws-calculatedPrice">{price*quantity}</span></p>
          </div>
          {/* delete button */}
          <div className="flex items-center justify-center col-span-2 mt-4 md:justify-end md:mt-0">
            <button className="lws-removeFromCart"onClick={()=>dispatch({type:"cart/remove",payload:id})}>
              <i className="text-lg text-red-400 fa-solid fa-trash" />
            </button>
          </div>
        </div>
    </>
  )
}

export default CartCard